// extracted by mini-css-extract-plugin
module.exports = {"home":"index_home__ZdSNF","banner":"index_banner__14p0R","part2":"index_part2__L-Fa7","part4":"index_part4__zgBzi","part5":"index_part5__2UJOH","part6":"index_part6__2pJRE"};